import React from 'react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { familiarItems } from '../../data/content';
export function FamiliarSection() {
  return <Section tone="white" data-id="element-73" data-mp="26afl58mssuxv">
      <div className="mx-auto max-w-3xl text-center" data-id="element-74" data-mp="26ca78q9t2t3j">
        <H2 data-id="element-75" data-mp="2ba2849sfhpjv">Does Any of This Sound Familiar?</H2>
        <p className="mt-4 text-lg text-ink/75" data-id="element-76" data-mp="2b8qwxownlfiq">
          If you’ve experienced even one of these situations, this system was designed with professionals like you in mind.
        </p>
      </div>

      <ol className="mt-10 grid gap-x-12 sm:grid-cols-2" data-id="element-77" data-mp="1im65kog6h3f6">
        {familiarItems.map((item, i) => <li key={item.title} className="flex gap-4 border-t border-ink/10 py-6" data-id="element-78" data-mp="1njock9amx8kj" data-mpi={i}>
            <span className="font-display text-3xl font-black leading-none text-accent-strong" data-id="element-79" data-mp="1rn4975mpf8x8">{i + 1}.</span>
            <div data-id="element-80" data-mp="2yyuzdsy3v985">
              <h3 className="font-display text-lg font-extrabold leading-snug" data-id="element-81" data-mp="2yzd4lf2qwxs7">{item.title}</h3>
              {item.body.map(p => <p key={p} className="mt-2 text-base leading-relaxed text-ink/75" data-id="element-82" data-mp="1x2kc9ozt8o27">{p}</p>)}
            </div>
          </li>)}
      </ol>

      <div className="mt-8" data-id="element-83" data-mp="1s495jn4tato7">
        <CtaButton label="Yes, this system is for me" note="Immediate Digital Access · $27 USD" data-id="element-84" data-mp="1n4mot3pryvan" />
      </div>
    </Section>;
}